<template>
  <div>
    <modal
      id="p-list-representation-record-modal"
      class="p-list-representation-record-modal"
      size="800px"
      :show.sync="show"
      :footer="false"
    >
      <div class="p-list-representation-record-modal-content w-100 row" >
        <Loader class="w-100 row" :loading="loading">
              <div class="form-group d-flex flex-wrap w-100 justify-content-center mb-0 col-10 mr-auto ml-auto">
                <form v-on:submit.prevent="submit" class="row w-100">

                    <div :class="{ 'p-list-representation-error': $v.formData.value_update_system_porsant.$error }" class="d-flex w-100 align-items-center flex-column mb-3" >
                      <label  class="ml-3 p-list-representation-label-text mb-2">
                        در صد
                      </label>
                      <input v-model="formData.value_update_system_porsant" type="number" placeholder="" class="form-control text-right w-100">
                    </div>

                    <div :class="{ 'p-commission-gender-error': $v.formData.gender.$error }" class="d-flex w-100 align-items-center flex-column mb-3" >
                      <label class="ml-3 p-list-representation-label-text mb-2">
                        جنیست
                      </label>
                      <multiselect
                       v-model="valueGender"
                       :options="genderData"
                       placeholder=""
                       label="title"
                       track-by="title"
                       :show-labels="false"
                       :allow-empty="false"
                       class="col-12"
                       >
                       </multiselect>
                    </div>

                    <div class="w-100 justify-content-center d-flex">
                      <button type="submit" class="btn btn-primary btn-blue btn-sm col-4">ثبت </button>
                    </div>

                </form>
              </div>
          </Loader>
      </div>

    </modal>
  </div>
</template>

<script>
import { required, minLength,between,numeric } from 'vuelidate/lib/validators'



export default {
    name: 'modalEditCommission',
    props: {
      active                      : { type: [Boolean, Number], default: false },
      valueModal                  : {type:Object,default:{}},
      loading                     : {type:Boolean,default:false},
    },

    data() {
      return {
        formData : {
        },
        genderData : [
          {
            id    : 'female',
            title : 'زن',
          },
          {
            id    : 'male',
            title : 'مرد',
          },
          {
            id    : 'unset',
            title : 'هر دو',
          },
        ],
        valueGender : {},
      }
    },

    validations: {
      formData : {
          value_update_system_porsant: {
              required,
          },
          gender: {
            required,
          },
      }
    },

    computed: {
      show: {
        set(val) {
          this.$emit('update:active', !!val)
        },
        get() {
          return !!this.active
        }
      },
    },

    mounted () {
      this.formData = this.valueModal;
    },

    watch: {
      show(status){
        if (!status) {
          this.$emit('closeModalCommission',status);
        }
      },

      valueModal(data){
        this.formData                  = data;
        let selectedValueDefaultGender = {};

        this.genderData.map((t)=>{
          if (t.id == data.gender) {
            selectedValueDefaultGender = t;
          }
        })

        this.valueGender                          = selectedValueDefaultGender
        this.formData.value_update_system_porsant = data.system_porsant;
      },

      valueGender(data){
        this.formData.lastGenderChange = data.id;
      },

    },

    methods: {
      submit(){
        this.$v.$touch()

        if (this.$v.$invalid) {
          this.$message.error('لطفا اطلاعات خود را بررسی کنید')
        }
        else {
          this.$emit('submitEditCommission',this.formData)
        }
      }

    },

}
</script>
